mtl.alloy.factory.fileupload = (function($, mtl) {
	'use strict';

	/**
	 * Async file upload control.
	 */
	return function(element, options) {

		var $element = $(element);
		var $progress = $(options.progressElement || '', element);

		/**
		 * Set the progress amount as a value in the range of [0..1].
		 */
		function setProgress(progress, instant) {

			$progress.css({
				width: (progress * 100.0).toFixed(4) + '%',
			});

			if (instant) {
				$progress
					.css({
						transition: 'none',
					})
					.delay(1)
					.queueCSS({
						transition: '',
					})
				;
			}

		}

		// Find the file input and initialise as an async uploader
		$element.find('input[type="file"]').fileupload({

			dataType: 'json',

			/**
			 * On sending a file upload.
			 */
			send: function(event, data) {

				setProgress(0, true);

				$element
					.removeClass('did-succeed did-fail')
					.addClass('is-uploading')
				;

			},

			/**
			 * On file upload done.
			 */
			done: function(event, data) {

				setProgress(1);

				$element
					.removeClass('is-uploading did-fail')
					.addClass('did-succeed')
				;

				$element.find('input[type="hidden"]').val(data.result.file);

			},

			/**
			 * On file upload fail.
			 */
			fail: function(event, data) {

				setProgress(1);

				$element
					.removeClass('is-uploading did-succeed')
					.addClass('did-fail')
				;

				if (options.alert) {
					var description = mtl.path.get(data, 'jqXHR.responseJSON.description');
					if (description) {
						alert(description);
					}
				}

			},

			/**
			 * On file upload progress.
			 */
			progress: function(event, data) {

				setProgress(data.loaded / data.total);

			},

		});

	};

}(jQuery, mtl));
